import { gql } from "config/graphql";
import { IDocument, IDocumentCategoryResData } from "config/types";
import { DOCUMENT_FIELDS } from "gql/fragments";
import { gqlQuery } from "store/apollo";

interface IFetchDocumentCategoriesResponse {
  data: {
    documentCategories: IDocumentCategoryResData[];
  };
}

export const fetchDocumentCategories = (): Promise<IFetchDocumentCategoriesResponse> => {
  const query = gql`
    ${DOCUMENT_FIELDS}
    query documentCategories {
      documentCategories {
        id
        name
        slug
        yearGroupable
        documents {
          ...DocumentFields
        }
      }
    }
  `;

  return gqlQuery<IFetchDocumentCategoriesResponse["data"]>({ query });
};

interface IFetchDocumentById {
  data: {
    document: {
      id: IDocument["id"];
      html: IDocument["html"];
      pdf: IDocument["pdf"];
    };
  };
}

export const fetchDocumentById = (documentId: string): Promise<IFetchDocumentById> => {
  const query = gql`
    query documentById($id: ID!) {
      document(id: $id) {
        id
        html {
          fileName
          url
        }
        pdf {
          fileName
          url
        }
      }
    }
  `;

  return gqlQuery<IFetchDocumentById["data"]>({
    query,
    variables: {
      id: documentId,
    },
  });
};
